import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import { Utilities } from "@learningblocks/exp-constants";
import { RenderHTML } from "@learningblocks/shared-components";
import "./style.scss";

const { COMPONENT_TYPE } = Utilities;
/**
 * Content to be displayed inside FullWidthCard - ModalWindow
 */
export function CardModalContent(props) {
  const renderContentByType = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <Image
            key={key}
            width="100%"
            tabIndex="0"
            src={component.image}
            alt={component.image}
          />
        );
      case COMPONENT_TYPE.PLAIN_TEXT:
      case COMPONENT_TYPE.SUB_HEADING:
        return <RenderHTML key={key} content={component.text} />;
      default:
        return null;
    }
  };

  return (
    <div className="technique-description">
      {props.components.map(renderContentByType)}
    </div>
  );
}

CardModalContent.propTypes = {
  /**
   * List of components to be displayed inside Card - Modal Window
   */
  components: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["FULL_WIDTH_IMAGE", "PLAIN_TEXT", "SUB_HEADING"]),
      image: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

CardModalContent.defaultProps = {
  components: [],
};
